import { c as _c } from "react/compiler-runtime";
import { ThemeImage } from '../ThemeImage';
import styles from './LoadingSpinner.module.scss';
import SpinnerDark from './spinner-dark.svg';
import SpinnerLight from './spinner-light.svg';
type Props = {
  className?: string;
  theme?: 'dark' | 'light';
};
export function LoadingSpinner(t0) {
  const $ = _c(3);
  const {
    className,
    theme
  } = t0;
  const t1 = `${styles.spinner} ${className ?? ""}`;
  let t2;
  if ($[0] !== t1 || $[1] !== theme) {
    t2 = <ThemeImage srcLight={SpinnerLight} srcDark={SpinnerDark} className={t1} alt="" data-theme={theme} />;
    $[0] = t1;
    $[1] = theme;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}